/**
 * Package: nfosongcycleMarquee
 *
 * NFO Song Cycle Marquee3k support and methods
 */

/**
 * Safe(r) shortcut for jQuery.
 */
if ( !$j ) {
    var $j = jQuery.noConflict();
}
        
var nfosongcycleMarquee = {
    /**
     * Initialize on document ready: setup Marquee3k
     */
    init: function() {
        // Init marquee(s) - the library is not enqueued everywhere, and this
        // runs inside a jQuery ready callback, where a throw stops the ready
        // callbacks queued after it.
        if ( 'undefined' === typeof Marquee3k ) return;

        Marquee3k.init();
        
        // Run methods that need to know about resize
        $j( window ).on( 'resize', function() {
            
        } );
    },
};

// Call init on ready
$j( nfosongcycleMarquee.init );
